import { Schema as S } from "effect";
export const SuperwallMockSchema = S.Literal("superwall-mock").pipe(S.brand("@open-revenue/schema/subscriptions/SubscriptionProvider"));
export const SuperwallMockFromString = S.compose(SuperwallMockSchema, S.Literal("superwall-mock"));
export const StripeSchema = S.Literal("stripe").pipe(S.brand("@open-revenue/schema/subscriptions/SubscriptionProvider"));
export const StripeFromString = S.compose(StripeSchema, S.Literal("stripe"));
export const PaddleSchema = S.Literal("paddle").pipe(S.brand("@open-revenue/schema/subscriptions/SubscriptionProvider"));
export const PaddleFromString = S.compose(PaddleSchema, S.Literal("paddle"));
export const Schema = S.Union(S.Literal("stripe"), S.Literal("superwall-mock"), S.Literal("paddle")).pipe(S.brand("@open-revenue/schema/subscriptions/SubscriptionProvider"));
export const Type = Schema.Type;
export const Stripe = "stripe";
export const SuperwallMock = "superwall-mock";
export const Paddle = "paddle";
// Test
export const make = (provider)=>S.decodeUnknown(Schema)(provider);
export const makeUnsafe = (provider)=>provider;
